import React from 'react';
export default class Contact extends React.Component {
    render() {
        return (<div>
           <iframe src="https://docs.google.com/forms/d/e/1FAIpQLSd0EbtWV8Rv-Y9qqI4GDPLk2sPuSsXfU6Hdzvq18A-SaAsXpw/viewform?embedded=true" width="100%" height="1000" frameborder="0" marginheight="0" marginwidth="0">Loading…</iframe></div>)
    }
}